import type { ColTypeDef } from 'ag-grid-community';
import { useNumberColumnType } from 'components/shared/Blotter/Grid/Hooks/useNumberColumnType';
import { useMemo } from 'react';

import { ColoredNumberCellRenderer } from './cellRenderers';

export function useColoredNumberType<T>(): ColTypeDef<T> {
  const numberColumn = useNumberColumnType<T>(3);
  return useMemo(
    () => ({
      ...numberColumn,
      cellRenderer: ColoredNumberCellRenderer,
    }),
    [numberColumn],
  );
}
